"use strict";

//
// Helper function to return the value of a cookie
//
// @example
//   getCookie('csrftoken')
//

var getCookie = void 0;

getCookie = function getCookie(name) {
    var cookie = void 0,
        cookieValue = void 0,
        cookies = void 0,
        i = void 0;
    cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        cookies = document.cookie.split(";");
        i = 0;
        while (i < cookies.length) {
            cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === name + "=") {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
            i++;
        }
    }
    return cookieValue;
};

module.exports = getCookie;